import { globalFeedbackMiddlewares } from 'pmt-modules/feedback/answer'
import { restaurantsGroupThemeMiddleware } from 'pmt-modules/restaurantsGroup'

export default [...globalFeedbackMiddlewares, restaurantsGroupThemeMiddleware]
